import { TriangleAlertIcon } from "lucide-react";
import type { FC } from "react";

export interface EvProductNameProps {
	productName: string;
	warning: string | null;
}

export const EvProductName: FC<EvProductNameProps> = props => {
	const {
		productName,
		warning
	} = props;

	return (
		<>
			{
				warning &&
				<TriangleAlertIcon className="mr-1 inline size-3.5 align-[-0.125em] text-warning" aria-label={warning} />
			}
			{productName}
		</>
	);
};
